import React from 'react';
import { Box, Typography } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import useInterveneSx from '../../hooks/useInterveneSx';

export default function EmptyState() {
  const interveneSx = useInterveneSx();

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        alignSelf: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 4,
      }}
    >
      <Box sx={{ ...interveneSx.iconCircle, width: 72, height: 72 }}>
        <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 36 }} />
      </Box>
      <Typography variant="h6" fontWeight={700} color="text.secondary">
        Select a conversation
      </Typography>
      <Typography variant="body2" color="text.disabled" textAlign="center" maxWidth={280}>
        Choose a user from the sidebar to view messages and start intervening
      </Typography>
    </Box>
  );
}
